import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class ParametroApi extends Api {
  async consultarParametro (codParametro) {
    try {
      const consultarParametroUrl = resolve('urlParametroConsultarParametro') + '/' + codParametro;
      const response = await this.fetch(consultarParametroUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async updateParametro (codParametro, valorParametro) {
    try {
      const updateParametroUrl = resolve('urlUpdateParametro') + '/' + codParametro + '/valor/' + valorParametro;
      await this.fetch(updateParametroUrl, 'post');
    } catch (error) {
      console.error(error);
    }
  }
}

export default ParametroApi;
